import { PlatformPermission } from '../types/auth';

const platformPermissionKeys = Object.keys(PlatformPermission) as Array<
  keyof typeof PlatformPermission
>;
// Separate export when needed as a standalone constant in
// non-developmenmt testing situations.
export const platformPermissions: Array<PlatformPermission> =
  platformPermissionKeys.map((k) => PlatformPermission[k]);

export const DEV_ENVIRONMENT_CONSTANTS = {
  emulatorPrivateKey:
    '-----BEGIN PRIVATE KEY-----\n' +
    'MIIJQgIBADANBgkqhkiG9w0BAQEFAASCCSwwggkoAgEAAoICAQC/pq8rqLXBglky\n' +
    'D+59bwLHAG+PQgzNlGlh45CXuLvQwiskQw+IY8WTdVH9taQ2SVtDj0maowA4b/Zu\n' +
    '6FS1qM2rWOvJK6RFbmtPZr2UGAkKazmpyRlC6J31KtwZqsp4q/xtXps0jHrM7zi/\n' +
    '6j8Y9uKGpr4A+xUtbpRZArMBVmOdKpenxjRXOpR2a3yO3iwuLqpgpzkJL39/+4+n\n' +
    'Gsg2Xh1E98IEETQUpQ6Go5ov1EV+ReT+aswQXRzroUJNdsGLLmNicKDicFGrcLwe\n' +
    '+oqse+TRiSWGizGVroP1K79SwR6YhP7wkZSuujuEqN3+MXcp0d5oedb/asa3niGm\n' +
    '5NlPEDj3bPj8BR7pjpRHEJ0351LUR8lOC2BtoYJ44R6/NVi0vphxiGnS37kN3cKo\n' +
    'zIxeHrI38zPHEPwRAqd69BoCqWTRJnPGc+SmrEirG3Osm1+IWocNJbCt1RzrZhYu\n' +
    'mJZoJdH6kDgntaua9Gj2eufO6maAPdl+NEXnq2gw/2JS+XcTL+J+RhXI4XptLay4\n' +
    'pcvQEV6MsHcO3NjaVUfK/pPfaXCm7fSn+D8ckdIvh6ke8IS0anyRJms5x1iGoUkj\n' +
    'pWvaQtP04ARV8gs7vGtpHOdTu2u4oSDj9rQCL3w5TPxmwcF+FbLGyo+/WIExNTfF\n' +
    'W8DImm6Pn4IJoQeVIDrRZZF7Je2ZOwIDAQABAoICAAwIWGcn/dawaw6MQYT5O0to\n' +
    'k5iC+nAjKUVOwafvnpsfaxCpGoiNpbykWQl80K/ihdWwDAb8Gj9w3XVee4hhmMgb\n' +
    '78cpnkldrWRxfDrtZ2PoEi6+xCnslj5A+qCslcRjHUN19SNPeUZJ9AjYmYLlEpkx\n' +
    'pCxGQgYgMzWDczRaStbLSHTtf3Zv5HJVkp8bA9sXwvVeimOGlT1hJfEalVy/Jpyg\n' +
    'kZB/zq1Hz6mptpHaL01w8KJTQjdPdp60o90JNQ2aqVK85Nz9VaNV6KRpRoZIdmKm\n' +
    'zFxY0ObSQNFbyx9UUKodb4QwdQ1N/qlNkOKCEzaPnqR17IcMxSfcyHAaCNVrR1Ll\n' +
    'sw5gpf80hwa/sreKOO7daBBlmnM8nUUBR2ro49HfDYapaZ0shHxvVkY5sTGXPIYx\n' +
    'Uj87a2HM7+I+msUWB8Wwios0RZHSEZTRI14DJnH/J10OrkRzgCuezgk6vUp+yTxw\n' +
    'HcOPHS5MtSYPJu7MRBL9gyCrbhgPTv5KNNPVa6X3ESshDGqqI7EIituQwQ8xW7Sw\n' +
    'cjQ+7rip/c+evW/JijMnbMEHgFNERe1pL4o+PAwpjFDhbYO0yI3wwg0D3i/2iwtG\n' +
    '9z7eqAusXSkqjt68Z0gBSBop8jb/q06R2jKNuSSqVijlE4GQ3V+uCCVFqo7cbeI8\n' +
    'MUtJOOhJ8sVCpaOwQl8BAoIBAQDk8SGm1gTJzzpL7Umcbad0QbokvgZGQ5blgBfc\n' +
    'TJlo/oFbHn/ZnTbERR8kFDx/O3i/zzqMJ6xwdkgD/XhHzkt0yOmv09EAhnNwZmyx\n' +
    'jdur8FewfY9dvD1YVNoNvlLSnW/VwaruSVRSr/xA8Jtl9216zU+SVyDhIhOW5Wb3\n' +
    'hcnoTMFv9SS1Ipa+4Zb7rFpYhU6ZPI1q6EDJ3MdgPOQRJsycv/lA6wBZCMj3v58e\n' +
    'pvmTOE7VoXAr4GvV8Mgh5lU4nsYEt1GVGN8eRj4HDwbCp67g8moNl0Qx0QGQtpty\n' +
    'xyHZMiLIR/5XsRMyyXq+j2Mvgq46ggYLI8IJjrhNaPZ7OQbxAoIBAQDWTUgi8suP\n' +
    'H+5R86t0gmQDC/HzkG7hb49IqK33ErzAprCIhyPbCN3+8SnDjH//zyvXHoAOCnyb\n' +
    'tc/7vrzEqogpxaw6T9VcktYcBoAMDRUF8F7O6pZPRYZ3AV6dWinPZ/CDaNHrVyen\n' +
    'pY9HQnx8ICVpPbyTaNXiOVLBuEYfgb/nFDDV/Wc1PRgzpzSFAMUK9bwXIaix9m6H\n' +
    'h/K+iytbUTFRtZEV0DR9kLhpR1t1On2ag3xb1pM2Kh+GKTYlv66OFeDrZzMdTfcj\n' +
    'Uck3MND/sQQTIVIhalRaxGE5UkuP82jLge7MlVGSN3IUhqQCkyrqC6cH3t1E/xsU\n' +
    '/RySwG4RW9rrAoIBABdsOCYqhUjkY7F68GoJqfUx+EpkCp5Lsfd++HH4gEWGrFNX\n' +
    'NntcI0tHSx1U2K+ntP3ixLmsIW9MGqgV2aV3DK9BEu+DO0HTf6IDSKGNwui/aSlM\n' +
    'X0uWw6vy2nBHhY+4vcVf0A4bAH6JNMSsGSoAe3nx4W82bM27v8dTZwpx7KtQlwXO\n' +
    'TdgeVs/mopzTEFc4JEd3M3y5kE9WwCsvb6H1lz9+QJEMufdh97WpLC1lpekS/LXM\n' +
    'k35Zso6r2L3nI9bsH5RB8R3Q8prVUulD90wY/cJT6tfDHx39pSxaEmNWzja7c2WM\n' +
    'QBBWtIEgrecrIlmtBAhGXznqiaKSsHZzA6yts/ECggEBALT5hK7G3XLb41Xf8m4s\n' +
    '4yrTfptS4OCOZrFUib06XJ5Q5ooVngkOXvM6VCuozjuIiBxdzISPBJY2nxKZDC8F\n' +
    'WIH2RjDkVGmeMyRttNr4fUWLrXUOFKuTKi/7vxwhFWfq/ejrr0MQUhO4s9vY4Omt\n' +
    '+An9MfBGu0EVabbg2I8o8pfBrFA6dFs4YeTVEnwznzNXPGVIbn8DfmoEO9IAEzhF\n' +
    'w+Gd9I04S+uyOJnnweuo3oOLAI1KEv3N6ttQmEKeslmZTl1dxIO94LQ6EDQEjKsx\n' +
    'oSBKpmJDukMAzp4qylchluEttC2e98kD+9orrfvirn4CIyd5ZOEskoFSEzw3N3x/\n' +
    'VssCggEAIFhpFDSERom8ZyeK/BqOJ41OBn+CIkDWP9UR1VH9U5R1JG2zb+oCEulz\n' +
    'gLkzwdkJDMsyGflubOfIzsoRuRmmQJc2UZWy+J09D+Z1yu8nZLgc4fR+BKxM6wiL\n' +
    'e1gx0iDdM2PF6kWvQ8utYI34dE62BDJ+PVI1xnrnMK55COEd04PPxAIWMpvxZTIG\n' +
    'FRsdXaOMaPoWL0BnGwkxaIKNVAr+7Ng7IKTY9OdqI2PhnyJ03pWNt992wzF6Cyc7\n' +
    'YNAwIDd5gbyDewsx4s7liWxSj4Tg3Q32BuzJXfXxhDbTRA32zCFUd1b1TkJIzvv9\n' +
    'Md28eCw9E7p11DWnb2rEgUIMcu8KFQ==\n' +
    '-----END PRIVATE KEY-----',
  emulatorPublicKey:
    '-----BEGIN PUBLIC KEY-----\n' +
    'MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAv6avK6i1wYJZMg/ufW8C\n' +
    'xwBvj0IMzZRpYeOQl7i70MIrJEMPiGPFk3VR/bWkNklbQ49JmqMAOG/2buhUtajN\n' +
    'q1jrySukRW5rT2a9lBgJCms5qckZQuid9SrcGarKeKv8bV6bNIx6zO84v+o/GPbi\n' +
    'hqa+APsVLW6UWQKzAVZjnSqXp8Y0VzqUdmt8jt4sLi6qYKc5CS9/f/uPpxrINl4d\n' +
    'RPfCBBE0FKUOhqOaL9RFfkXk/mrMEF0c66FCTXbBiy5jYnCg4nBRq3C8HvqKrHvk\n' +
    '0Yklhosxla6D9Su/UsEemIT+8JGUrro7hKjd/jF3KdHeaHnW/2rGt54hpuTZTxA4\n' +
    '92z4/AUe6Y6URxCdN+dS1EfJTgtgbaGCeOEevzVYtL6YcYhp0t+5Dd3CqMyMXh6y\n' +
    'N/MzxxD8EQKnevQaAqlk0SZzxnPkpqxIqxtzrJtfiFqHDSWwrdUc62YWLpiWaCXR\n' +
    '+pA4J7WrmvRo9nrnzupmgD3ZfjRF56toMP9iUvl3Ey/ifkYVyOF6bS2suKXL0BFe\n' +
    'jLB3DtzY2lVHyv6T32lwpu30p/g/HJHSL4epHvCEtGp8kSZrOcdYhqFJI6Vr2kLT\n' +
    '9OAEVfILO7xraRznU7truKEg4/a0Ai98OUz8ZsHBfhWyxsqPv1iBMTU3xVvAyJpu\n' +
    'j5+CCaEHlSA60WWReyXtmTsCAwEAAQ==\n' +
    '-----END PUBLIC KEY-----',
  middlewarePrivateKey:
    '-----BEGIN PRIVATE KEY-----\n' +
    'MIIJQgIBADANBgkqhkiG9w0BAQEFAASCCSwwggkoAgEAAoICAQC2JwNZzQdiLqMp\n' +
    'gMpuqUf6pvkihGQsh6/8F13xhI2iQ/TxmjSXcGz9n2at4uwODNLu4dSZnizI8DUA\n' +
    'E3801A4HROseHIwf+a8VChUWbkLRNo4m/nTX7IPhMM3N906BQXiwxVErKrSosQyG\n' +
    'wGl6eJrwHXk4nKlG78IaxjqxygWDdGwIToeFc8pdSTiBltAwpdBSraoMu226GcW3\n' +
    'nVBr3gFyhgGx/fq5YkXbe1pfzgT/Cufh73F/JKRQQYPaYWYXoAcKu6qurZWxnl0J\n' +
    'LWonzVOOHS8p3C7IC9V/Wksax491cs/0c12rxcrJWxgxHMYBcbiW1sogjAHFFA9n\n' +
    'yQGEVrT2MSRXJ/2x9X2c0ICkrirPHmw/kRQHRbDx9HToDPFuKmXoeO5Hl6olsvk3\n' +
    'H/eD/0K+RuV4oHEWlNKmKOaGc7Zwd4wQvY25A3rwvu2TQtp9C0I3u8WmKhqxYtJg\n' +
    'Uu6i5xupjiTKxNRslHckbt4lbJSPcx4lQXvMsMANVoBf+tDaXWAgCxVtjGBp8IsL\n' +
    'HiVWneqnIAGb5/1+ygrHToHclK+Y1SSjkjP4t8Dlz2gLEUo4L9fjBuBSWWLhf1Jd\n' +
    'E90gVy8BD+oifZFCpW7VEpR7RsHK/T8gWV8iecx/4xEWPUD/3rJVQpSh3gtArvlJ\n' +
    'Rg/1abheQt3S06D5SWCs7v5g1ttb2QIDAQABAoICABAoQUCVsnY3z1LG4Q30V5Vo\n' +
    '+rfgWPdnOMnKc9OQz7RpRUCqDkixmQVdPpEljA1J/2rfnslakbvoLLdbQ2EW/0CP\n' +
    'UTC8VQSgE/LwkELLWINwzKayUwB1MxSGTPccXPsTqOY7NnI3CUveWo9YYXLS4GF0\n' +
    'p9RI9y365fOUik/LbPZGXS/WcWh5xyVDsa6zBzgNeT9gNrGG7ZqAnzxkiKXszSGQ\n' +
    't/VHI1aO3EX1+OP/JQvPdpags+dUg3u39/9mvNTTJdTCpUb10E2vT67Y963cpXD5\n' +
    'bz3OEVs+y3sOshNHyNag7sfO9Ovf8VcvjKOMmxa1NOuyVT8SVDTcTOqGlqsbutTm\n' +
    'A8o582hM2ViLlncglSpb2Wpn4K+r89UfjAQLTHsgYjEF23mqKteLH7FE2dhQnsi5\n' +
    'q8bOvsjE9go7GAOQ1AIMZN5JTyf7ElWLlZZ+nAISdvJN4nYCxzlX3CCEtaYcTKre\n' +
    'GUYF56kZxz7BMlx6E1AMQ8JIJM7+Z2PRF2zEGmgl4WB3TMrjriN4GxHDxVHPTwgC\n' +
    '3ssD8FRY3bFZN2oQ5eFVFjhm7CiC1VouID69Iy2oaNIlefeCY70FPINy0I6AJXzh\n' +
    'v7nDa9bkLcf8BOTpPzuWpGU9VFQ4uSZgxt9OvCAAu2YqtUc2ZJWDTQegEl/JpS21\n' +
    'gWP5kAD2PVvdHsBZnqBBAoIBAQD4QMaLMveK0EnP/rD/cfww156HK8YI+mDPKTp7\n' +
    'gLKEQJkFf1gOH9EuXK3iOdxwSHw9wliGtDdsjGtrV+BBCGmi0JqsMtoocE+306/1\n' +
    'JkzxfkiCP8RBvp8/1OSg8eFkt2XWzXa6Jar8kDI1kQaGgY/x/cATdyYus4KiAsPJ\n' +
    'wdXVw7OLCbRvuV8KdnNO+hnldVvP4ynwDP+LVYidiOeSAolF9JwdEikQblgV2k9f\n' +
    'IKTTPCCkV/p0QH98KaL6FCOXYg9yGxD41iDqDKWFrKcG/e5tQ74pibkGJKcIkKsB\n' +
    '6E6pBD1UIlwLKZS9s9auDYowS4vagtIw/+kSWHepnPWpubh5AoIBAQC71i2NCBrs\n' +
    'mk4EhotYTs6AbAbDVVgY8ZLbgUR1jXh8rn2iBmEMV4jptfYcTOw0Bm4Y1iCHaKCt\n' +
    '+BOmxKSY+aqOGZ23MOmGT5NH2ibCkVt9WA2eLj3kHylwkwGb5S6MTH+/1YiuNQlr\n' +
    'wvG4T5FxTrff0Lf5ZozkFMoCb+YVxRnaaT+KkgGvx62879arJ1YaN4/RPrf0pLqv\n' +
    'zhsDmNJ4r/qncFicr5pvUvMInW1svb+Moc/ehpUc/uotR4A7c5AiGnhkrTx4bdUe\n' +
    'AjAs/JLhZdO9CzsukIY3hG/FzdgCo+43/D3/Oh4d147nqINKXFPGCarSLDxXSD/+\n' +
    '6hT+Gd7NTqZhAoIBAQDMQHdalf+HjaH9aL72HTFyeiUrb7+LKX23VGOSs6utFn0Q\n' +
    'QdsQG+t+qrBCPnr5Qxo9sgYmJmanf8ztz6ppt2M6m0l3Poux094zEA9osy+BTfaY\n' +
    'e6CcuxrJaP8G0JwywpYeqoPx2gYZsQYufnkQ986YOr/rBBA9QmLLq1ytRjcKnu69\n' +
    'CaoUdj8VG6n5o9rkqK92lp+tqvQiDqjNfJOS1VVeYkiDvqpco30D1c+SJAiY55Kv\n' +
    'xNcDCQIbBSLbgPBboEm3Bz/qjDsednNFTW1LWmfuLFtsT60UudlYObcJZbo6Y4uW\n' +
    'CoMSiA6iGjIamHdHDxEtIo+P0y5PcsxZmBOjpnN5AoIBAByipykT7j7Zu0EXXdDl\n' +
    'mrebQGCw9xA+a7wI9e3R1mdzlnWH8W2XPqkac12XIH9B57Djm+vouG4tHpnS6qDj\n' +
    'luu43gFadI9kPDi8+iG5VTBDpzfRJuBLG98smhcxFiqPUv5kyER+k2QZQQ5vGuYi\n' +
    'MQfu4s0jpCD1RmKeun3hIXLZjrVKUvWARG1ERv6qrYarp8InhJXIMymwCxA+UP/T\n' +
    'HCxAhVHFt453H9PVZCQqvTPsSytKaxsThZHHj7YAhR2d2XLHsitN2yqK/Nsu2hmA\n' +
    'k4oDV09e+wclqoCGRAMLCLsCOlVZf9Pe08tfNjy03JSZTrBhzAUmX5M2DmM6gGve\n' +
    'LKECggEABmcSwidOF4qlPnOlaqzGENuTbjUPU3jZ38tuFDx7X5QwvONayd1eX6QH\n' +
    'tPF4j+YGbD8QI6UTvXc4XG5XOuBTUexDbAd9gagYs8SCEJQRbiWgsYfg6n484WVw\n' +
    'F532sYoNCT3cD+HL3EtKzJvopnsbX2kXnTTZNHkktxRSzEkHIbul/533h3xKY0uS\n' +
    'kLAZgWC+Tx0B494SO0himpuSG1uEgDEbwxLR6hoyvrcF9b+8/0gSde1D3n5FRcJk\n' +
    'hxZzh4zmcpxqgR6+XabmdmUYmyeWWJQDphK6rVuUVQZMkBUEGxoj0RGoy7NxBy7R\n' +
    'QlxMXIvfOXIaAMryf8gaCDb7dfIR3A==\n' +
    '-----END PRIVATE KEY-----',
  middlewarePublicKey:
    '-----BEGIN PUBLIC KEY-----\n' +
    'MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAticDWc0HYi6jKYDKbqlH\n' +
    '+qb5IoRkLIev/Bdd8YSNokP08Zo0l3Bs/Z9mreLsDgzS7uHUmZ4syPA1ABN/NNQO\n' +
    'B0TrHhyMH/mvFQoVFm5C0TaOJv501+yD4TDNzfdOgUF4sMVRKyq0qLEMhsBpenia\n' +
    '8B15OJypRu/CGsY6scoFg3RsCE6HhXPKXUk4gZbQMKXQUq2qDLttuhnFt51Qa94B\n' +
    'coYBsf36uWJF23taX84E/wrn4e9xfySkUEGD2mFmF6AHCruqrq2VsZ5dCS1qJ81T\n' +
    'jh0vKdwuyAvVf1pLGsePdXLP9HNdq8XKyVsYMRzGAXG4ltbKIIwBxRQPZ8kBhFa0\n' +
    '9jEkVyf9sfV9nNCApK4qzx5sP5EUB0Ww8fR06Azxbipl6HjuR5eqJbL5Nx/3g/9C\n' +
    'vkbleKBxFpTSpijmhnO2cHeMEL2NuQN68L7tk0LafQtCN7vFpioasWLSYFLuoucb\n' +
    'qY4kysTUbJR3JG7eJWyUj3MeJUF7zLDADVaAX/rQ2l1gIAsVbYxgafCLCx4lVp3q\n' +
    'pyABm+f9fsoKx06B3JSvmNUko5Iz+LfA5c9oCxFKOC/X4wbgUlli4X9SXRPdIFcv\n' +
    'AQ/qIn2RQqVu1RKUe0bByv0/IFlfInnMf+MRFj1A/96yVUKUod4LQK75SUYP9Wm4\n' +
    'XkLd0tOg+UlgrO7+YNbbW9kCAwEAAQ==\n' +
    '-----END PUBLIC KEY-----',
  platformFeatures: ['multilang', 'notification', 'userpicker'],
  azureStorageConnectionString:
    'AccountName=devstoreaccount1;AccountKey=Eby8vdM02xNOcqFlqUwJPLlmEtlCDXJ1OUzFT50uSRZ6IFsuFq2UVErCz4I6tq/K1SZFPTOtr/KBHBeksoGMGw==;DefaultEndpointsProtocol=http;BlobEndpoint=http://blob:10000/devstoreaccount1;QueueEndpoint=http://blob:10001/devstoreaccount1;TableEndpoint=http://blob:10002/devstoreaccount1;',
  platformPermissions,
  tenantData: [
    { branch_id: '11f317fce4b056081c345668', branch_slug: 'evil.corp' },
    { branch_id: '22f317fce4b0560e4b06c6fb', branch_slug: 'ZORG.Industries' },
  ],
} as const;

export const THUMBNAIL_SETTINGS = { tiny: 75, big: 1080 };

export const SUPPORT_EMAIL = 'ees-support@telekom.de';
